// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IAnnotationItem,
}                               from '../interfaces';

// ===== Enums =====

import {
    ZOOM_LEVEL,
}                               from '../components/Editor/elements/enums';

const getAnnotations = async ({
    test,
    postId,
    userId,
    zoomLevel,
    chapterId,
    sectionId,
}: {
    test: boolean,
    postId?: string,
    userId?: string,
    zoomLevel?: ZOOM_LEVEL,
    chapterId?: string,
    sectionId?: string,
}): Promise<Map<string, IAnnotationItem>> => {
    const functions = getFunctions();
    const handleGetAnnotations = httpsCallable<
        Record<
            string,
            boolean | string | number | undefined
        >,
        {
            [k: string]: IAnnotationItem,
        }
    >(
        functions,
        'getAnnotations',
    );
    return handleGetAnnotations({
        test,
        postId,
        userId,
        zoomLevel,
        chapterId,
        sectionId,
    }).then((result) => {
        const annotations: Map<string, IAnnotationItem> = new Map(Object.entries(result.data));
        return annotations;
    }).catch((err) => {
        throw err;
    });
};

export default getAnnotations;
